// store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../services/authServices/loginService';
import assessmentReducer from '../services/assessmentSlice'; 
// 1. استيراد الـ Reducer الخاص بتحديث التقييم
import updateAssessmentReducer from '../services/updateAssessmentSlice'; 

const store = configureStore({
  reducer: {
    auth: authReducer,
    assessment: assessmentReducer, 
    updateAssessment: updateAssessmentReducer, 
  },
});

export default store;